import { modal } from "./modals";
import {toggler} from "./menu";

function modalOpen(idOpen, idModal) {

    /*jQuery(function ($){
        $( "a[href='#"+ idAncla +"']" ).click(function (e){
            e.preventDefault();

            modal(idModal);

            jQuery(function ($){
                $('ul.menu li').removeClass('current-menu-item');
                $('ul.menu li a[href="#'+idAncla+'"]').parent().addClass('current-menu-item');
                return false;
            });

            //this.parentElement.classList.add("current-menu-item");


        })
    })*/
    console.log('Ingreso al metodo...')
    let popup = document.getElementById(idOpen);

    if (!popup) {
    } else {
        popup.addEventListener('click', (e) => {
            e.preventDefault();
            toggler();
            modal(idModal);
        })
    }

}
export { modalOpen }
